import { memo } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { CustomCheckbox } from "../../CustomCheckbox";
import { Contact } from "../../../../types";

export const ContactItem = memo(
  ({
    contact,
    toggleSingle,
    isSelected,
  }: {
    contact: Contact;
    toggleSingle: (id: string) => void;
    isSelected: boolean;
  }) => {
    const { added, updated, deleted, account_name, account_id } = contact;

    const changes: string[] = [];
    if (added) changes.push(`${added} added`);
    if (updated) changes.push(`${updated} updated`);
    if (deleted) changes.push(`${deleted} deleted`);

    return (
      <Box
        onClick={() => toggleSingle(account_id)}
        sx={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
        }}
      >
        <CustomCheckbox checked={isSelected} />
        <Stack justifyContent="center">
          <Typography color="#1F2932">{account_name}</Typography>
          <Typography color="#1F293299" fontSize="12px" lineHeight="12px">
            {changes.join(", ")}
          </Typography>
        </Stack>
      </Box>
    );
  },
);
